import { render, staticRenderFns } from "./commissionGrantExtra.vue?vue&type=template&id=e708d68a"
import script from "./commissionGrantExtra.vue?vue&type=script&lang=js"
export * from "./commissionGrantExtra.vue?vue&type=script&lang=js"
import style0 from "./commissionGrantExtra.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports